/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useState, useContext, useEffect } from "react";
import { Banner, ResourceList } from "lib/components";
import { QuickReport } from "app/reports";
import { useQuery, useMutation } from "@apollo/client";
import { LegacyCard as Card, Tabs, ResourceItem, Thumbnail, Badge, InlineStack, Text } from "@shopify/polaris";

import { baseHelper, imageHelper, errorHelper } from "lib/helpers";
import { PrivateContext } from "lib/context";

import GET_WOOCOMMERCE_TEMP_PRODUCT_LIST from "app/productOld/apollo/queries/getTempWooCommerceProductList";
import { SYNC_VENDOR_WOOCOMMERCE_PRODUCT } from "app/productOld/apollo/mutations";
import GET_WOOCOMMERCE_TEMP_PRODUCT_SUBSCRIPTION from "app/productOld/apollo/subscriptions/tempWooCommerceProductList";

import constant from "lib/constant/constant";
import Popover from "lib/components/popover/popover";

import { withErrorBoundary, withFeature } from "lib/hoc";
import { useLocation, useNavigate } from "react-router-dom";

const List = () => {
  const { currentUser, cms = {} } = useContext(PrivateContext);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = baseHelper.getQueryParams(location.search);
  const [selected, setSelected] = useState(parseInt(queryParams.tab, 10) || 0);
  let searchVal = queryParams.search && queryParams.search.split("+");
  searchVal = searchVal && searchVal.length && searchVal.join(" ");
  // eslint-disable-next-line no-unused-vars
  const [values, setValues] = useState(searchVal || "");
  // eslint-disable-next-line no-unused-vars
  const [selectedAction, setSelectedAction] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [appliedFiltersValue, setAppliedFiltersValue] = useState([]);
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const getQueryParams = baseHelper.getQueryParams(location.search);
  const [queryValue, setQueryValue] = useState(getQueryParams.search || "");
  const [sortValue, setSortValue] = useState("");
  const [listLoading, setListLoading] = useState(false);
  const [popoverActive, setPopoverActive] = useState(true);
  const [page, setPage] = useState(getQueryParams.page || 1);
  const [perPage, setPerPage] = useState(getQueryParams.perPage || 20);
  const [banner, setBanner] = useState({
    isOpen: false,
    status: "",
    title: "",
    action: null,
  });

  const [tempData, setTempData] = useState([]);

  if (!getQueryParams) {
    getQueryParams.search = "";
    getQueryParams.sort_name = "";
    getQueryParams.sort_order = "";
    getQueryParams.filter = "";
  }

  const inputData = {
    search: getQueryParams.search,
    sort_name: getQueryParams.sort_name,
    sort_order: getQueryParams.sort_order,
    filter: getQueryParams.filter,
    page: parseInt(getQueryParams.page || page, 10),
    perPage: parseInt(getQueryParams.perPage || perPage, 10),
  };

  const { loading, data, subscribeToMore, refetch } = useQuery(GET_WOOCOMMERCE_TEMP_PRODUCT_LIST, {
    variables: {
      input: inputData,
    },
  });

  const [bulkProductActions] = useMutation(SYNC_VENDOR_WOOCOMMERCE_PRODUCT, {
    refetchQueries: [
      {
        query: GET_WOOCOMMERCE_TEMP_PRODUCT_LIST,
        variables: {
          input: inputData,
        },
      },
    ],
  });

  const tempDataResponse = baseHelper.getResponseData(data, "getTempWooCommerceProductList");

  useEffect(() => {
    if (tempDataResponse) {
      setTempData(tempDataResponse);
    }
  }, [tempDataResponse]);

  useEffect(() => {
    subscribeToMore({
      document: GET_WOOCOMMERCE_TEMP_PRODUCT_SUBSCRIPTION,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;
        return refetch();
      },
    });
  }, [subscribeToMore, refetch]);

  useEffect(() => {
    const paramValue = baseHelper.getQueryParams(location.search);
    const listFilter = (paramValue.list_filter && paramValue.list_filter.split(",")) || [];
    const listSearch = (paramValue.list_search && paramValue.list_search.split(",")) || [];
    const appliedFilters = [];
    listFilter.forEach((item, index) => {
      appliedFilters.push({
        key: item,
        value: listSearch[index],
      });
    });
    setAppliedFiltersValue(appliedFilters);
  }, [location.search, values]);

  const handleSearchValue = (searchValue) => {
    const search = baseHelper.setQueryParams(location, { search: searchValue });
    setQueryValue(searchValue);
    navigate(`${location.pathname}?${search}`);
  };

  const handleSort = (select) => {
    const sort = select.split("_");
    if (sort && sort.length === 2) {
      setSortValue(select);
      const sortedValue = baseHelper.setQueryParams(location, { sort_name: sort[0], sort_order: sort[1] });
      navigate(`${location.pathname}?${sortedValue}`);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const tabsData = [
    { id: "all", panelID: "all", content: cms("section.label.all"), value: "all" },
    { id: "synced", panelID: "synced", content: cms("section.label.synced"), value: "synced" },
    { id: "unsynced", panelID: "unsynced", content: cms("section.label.unsynced"), value: "unsynced" },
  ];
  const handleTabChange = useCallback(
    (selectedTabIndex) => {
      setSelected(selectedTabIndex);
      const filterValue = baseHelper.setQueryParams(location, {
        filter: tabsData[selectedTabIndex].value,
        tab: selectedTabIndex,
      });
      navigate(`${location.pathname}?${filterValue}`);
    },
    [navigate, tabsData]
  );

  const handleSync = async (eventKey, id = false) => {
    let formData = {};

    const searchParams = {
      search: searchVal,
    };

    formData = {
      // all: false,
      ids: selectedItems,
      key: eventKey,
      searchParams,
    };

    if (id) {
      formData.ids = [id];
      // formData.all = false;
      setListLoading(`${eventKey}_${id}`);
    }

    await bulkProductActions({ variables: { input: { ...formData } } })
      .then((res) => {
        setListLoading(false);
        if (res) {
          const responseData = baseHelper.getResponseData(res.data, "syncVendorWooCommerceProduct");
          const responseDataError = baseHelper.getResponseError(res.data, "syncVendorWooCommerceProduct");

          if (responseData) {
            const title = cms("message.success.request");
            setBanner({ isOpen: true, title, status: constant.SUCCESS });
            setSelectedItems([]);
          }

          if (responseDataError) {
            setBanner({ isOpen: true, title: responseDataError, status: constant.CRITICAL });
          }
        }
      })
      .catch((exception) => {
        setListLoading(false);
        setBanner({ isOpen: true, title: errorHelper.parse(exception), status: constant.CRITICAL });
      });
  };

  const bulkActions = [
    {
      content: cms("section.label.syncProduct"),
      onAction: () => handleSync("approve"),
    },
  ];

  const handleChange = (val, _id) => {
    setSelectedButtonIndex(_id);
    if (val === "sync") {
      handleSync("approve", _id);
    }
  };

  const handleQueryClear = () => {
    handleSearchValue("");
    baseHelper.setUrl(location, navigate, { search: "" });
  };

  const topSpace = {
    marginTop: "0.5em",
  };

  return (
    <>
      {banner.isOpen && (
        <>
          <Banner
            isOpen={banner.isOpen}
            status={banner.status}
            title={banner.title}
            action={banner.action}
            onDismiss={() => setBanner({ isOpen: false })}
          />
          <br />
        </>
      )}
      <Banner title={cms("message.success.addInstruction")} isOpen status={constant.INFO} />
      <br />
      <Banner title={cms("message.success.importInstruction")} isOpen />
      <br />
      <QuickReport />

      <Card>
        <Tabs tabs={tabsData} selected={selected} onSelect={handleTabChange} />
        <ResourceList
          resourceName={{ singular: cms("section.label.product"), plural: cms("section.label.productPlural") }}
          items={tempData.tempProductList}
          idForItem={(item) => {
            const { _id } = item;
            return _id;
          }}
          selectable
          bulkActions={bulkActions}
          selectedItems={selectedItems}
          onSelectionChange={setSelectedItems}
          loading={loading}
          sortValue={sortValue}
          sortOptions={[
            { label: cms("section.label.dateDesc"), value: "createdAt_desc" },
            { label: cms("section.label.dateAsc"), value: "createdAt_asc" },
            { label: cms("section.label.titleAsc"), value: "name_asc" },
            { label: cms("section.label.titleDesc"), value: "name_desc" },
          ]}
          onSortChange={handleSort}
          onQueryChange={handleSearchValue}
          onQueryClear={handleQueryClear}
          queryValue={queryValue}
          count={tempData.count}
          page={page}
          perPage={perPage}
          setPage={setPage}
          setPerPage={setPerPage}
          renderItem={(item) => {
            const { _id, image, isShopifySync, name, updatedAt } = item;
            const thumbnailImage = image
              ? imageHelper.resize({ url: image, type: constant.imageTypes.THUMBNAIL })
              : constant.NOIMAGESNAP;

            const syncedStatusType = (isShopifySync && constant.SYNCED) || constant.NOT_SYNCED;
            const syncedStatus = (isShopifySync && cms("section.label.synced")) || cms("section.label.unsynced");
            return (
              <ResourceItem id={_id}>
                <InlineStack wrap={false}>
                  <Thumbnail size={constant.LARGE} source={thumbnailImage} alt={`${name} image`} />
                  <Text as="h2" variant="headingSm">
                    <div className="content-text-wrap">
                      <Text as="span" fontWeight="semibold">
                        {name}
                      </Text>
                    </div>
                  </Text>
                  <div className="content-text-wrap">
                    <Text variant="bodySm" as="p">
                      {`${cms("section.label.by")} `}
                      <b>{currentUser.brandName}</b>
                      {` ${cms("section.label.on")} ${baseHelper.formatDate(updatedAt)}`}
                    </Text>
                  </div>
                  <div style={topSpace}>
                    <InlineStack>
                      <Badge status={baseHelper.getBadgeType(syncedStatusType)}>
                        {baseHelper.ucFirst(syncedStatus)}
                      </Badge>
                    </InlineStack>
                  </div>
                  <Popover
                    active={popoverActive[_id]}
                    setActive={() => setPopoverActive({ [_id]: !popoverActive[_id] })}
                    loading={_id === selectedButtonIndex && listLoading}
                    disabled={isShopifySync}
                    options={[
                      {
                        content: cms("section.label.sync"),
                        onAction: () => handleChange("sync", _id),
                      },
                    ]}
                  />
                </InlineStack>
              </ResourceItem>
            );
          }}
        />
      </Card>
    </>
  );
};

export default withFeature(withErrorBoundary(List), { feature: constant.WOOCOMMERCE_PRODUCT });
